<div class="dialog-container">
  <div class="dialog-header pl-35 mt-20">
    <div class="dialog-header-title">
      {{ currentTitle }}
      <ng-container *ngIf="currBothDLTKPlatformActive">
        - {{ currBothDLTKPlatform.name }}
        <img
          class="order-type-img"
          src="{{ currBothDLTKPlatform.img_src }}"
          [alt]="currBothDLTKPlatform.name"
        />
      </ng-container>
    </div>
    <div class="dialog-header-cross m-r-35" (click)="cancel_clicked()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>

  <hr class="hr-line" />

  <div class="dialog-form">
    <div class="confirm-class">
      <div class="order-content-rc" id="new-order-details-id">
        <div class="mt-25 mb-25 mr-25 ml-25">
          <ng-container *ngIf="!isPlatformMenuSync || !showAutoSync">
            <!-- Order Type -->
            <div
              class="grid-row"
              *ngIf="modalState?.showOrderType && !currBothDLTKPlatformActive"
            >
              <div
                class="order-card"
                *ngFor="let item of orderType"
                (click)="orderTypeClicked(item)"
              >
                <img
                  class="order-type-img"
                  src="{{ item.img_src }}"
                  [alt]="item.name"
                />
                <p class="order-type-text" *ngIf="(item.order_type !== 2 && item.order_type !== 0) else localOrderType">{{ item.name }}</p>
                <ng-template #localOrderType>
                  <p class="order-type-text">
                    <ng-container [ngSwitch]="item.order_type">
                      <ng-container *ngSwitchCase="0">{{ 'POS.DINE_IN' | fallbackTranslate }}</ng-container>
                      <ng-container *ngSwitchCase="2">{{ 'POS.TAKEAWAY' | fallbackTranslate }}</ng-container>
                    </ng-container>
                  </p>
                </ng-template>
              </div>
            </div>
            <!-- Tk DL tags for offline platforms -->
            <div class="flex_se" *ngIf="currBothDLTKPlatformActive">
              <div class="order-card" (click)="setPlatformOrderTypeClicked(1)">
                <img
                  class="order-type-img"
                  [src]="images.MAP"
                  [alt]="currBothDLTKPlatform.name"
                />
                <p class="order-type-text">
                  {{ currBothDLTKPlatform.name }}
                  {{ 'POS.DELIVERY' | fallbackTranslate }}
                </p>
              </div>
              <div class="order-card" (click)="setPlatformOrderTypeClicked(2)">
                <img
                  class="order-type-img"
                  [src]="images.LUNCH"
                  [alt]="currBothDLTKPlatform.name"
                />
                <p class="order-type-text">
                  {{ currBothDLTKPlatform.name }}
                  {{ 'POS.PICK_UP' | fallbackTranslate }}
                </p>
              </div>
            </div>
            <!-- Tk DL tags for offline platforms end -->
            <!-- User Details -->
            <div *ngIf="modalState?.showCustomer">
              <div class="flex-row">
                <form [formGroup]="customerForm">
                  <div class="form-container">
                    <div class="form-group" class="form-input-container">
                      <div class="form-area">
                        <label>
                          {{ 'POS.CUSTOMER_NAME' | fallbackTranslate }}
                        </label>
                        <input
                          type="text"
                          placeholder="{{ 'POS.ENTER_NAME_HERE' | fallbackTranslate }}"
                          id="name"
                          class="input-name-class"
                          name="name"
                          formControlName="name"
                          [ngClass]="{
                            'is-invalid':
                              (customerForm.get('name').errors &&
                                customerForm.get('name').touched) ||
                              (customerForm.get('name').touched &&
                                customerForm.get('name').hasError('name'))
                          }"
                        />
                        <p
                          class="alert-text"
                          *ngIf="
                            customerForm.get('name').hasError('required') &&
                            customerForm.get('name').touched
                          "
                        >
                          {{ 'POS.REQUIRED' | fallbackTranslate }}
                        </p>
                      </div>

                      <div class="form-area">
                        <label>
                          {{ 'POS.DIAL_CODE' | fallbackTranslate }}
                        </label>
                        <input
                          type="text"
                          placeholder="{{ 'POS.ENTER_DIAL_CODE' | fallbackTranslate }}"
                          class="input-name-class"
                          name="dial_code"
                          formControlName="dial_code"
                          [ngClass]="{
                            'is-invalid':
                              (customerForm.get('dial_code').errors &&
                                customerForm.get('dial_code').touched) ||
                              (customerForm.get('dial_code').touched &&
                                customerForm
                                  .get('dial_code')
                                  .hasError('dial_code'))
                          }"
                        />
                        <p
                          class="alert-text"
                          *ngIf="
                            customerForm
                              .get('dial_code')
                              .hasError('required') &&
                            customerForm.get('dial_code').touched
                          "
                        >
                          {{ 'POS.REQUIRED' | fallbackTranslate }}
                        </p>
                      </div>

                      <div class="form-area">
                        <label>
                          {{ 'POS.CUSTOMER_MO_NUM' | fallbackTranslate }}
                        </label>
                        <input
                          type="text"
                          placeholder="{{
                            'POS.ENTER_NUMBER_HERE' | fallbackTranslate
                          }}"
                          id="number"
                          class="input-name-class"
                          name="number"
                          formControlName="number"
                          [ngClass]="{
                            'is-invalid':
                              (customerForm.get('number').errors &&
                                customerForm.get('number').touched) ||
                              (customerForm.get('number').touched &&
                                customerForm.get('number').hasError('number'))
                          }"
                        />
                        <p
                          class="alert-text"
                          *ngIf="
                            customerForm.get('number').hasError('required') &&
                            customerForm.get('number').touched
                          "
                        >
                          {{ 'POS.REQUIRED' | fallbackTranslate }}
                        </p>

                        <p
                          class="alert-text"
                          *ngIf="customerForm.get('number').errors?.minlength"
                        >
                          {{ 'POS.INCORRECT_NUMBER' | fallbackTranslate }}
                        </p>
                      </div>
                    </div>

                    <div
                      class="form-group"
                      class="form-input-container"
                      *ngIf="this.selectedOrder.platform == 'others'"
                    >
                      <div class="form-area">
                        <label>
                          {{ 'POS.ENTER_ORDERING_PLATFORM_NAME' | fallbackTranslate }}
                        </label>
                        <input
                          type="text"
                          placeholder="{{ 'POS.ENTER_HERE' | fallbackTranslate }}"
                          id="address"
                          class="input-name-class"
                          name="address"
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <button class="save wd-100" (click)="userDetailsClicked()">
                {{ 'POS.SAVE' | fallbackTranslate }}
              </button>
            </div>
            <!-- Table Select -->
            <div class="mb-20" *ngIf="modalState?.showTable">
              <nz-select [(ngModel)]="selectedSection" class="section-dropdown" (ngModelChange)="change($event)"
                [nzPlaceHolder]="'POS.SELECT_SELECTION' | fallbackTranslate" nzSize="large">
                <nz-option *ngFor="let section of allSections" [nzValue]="section.floor_id" [nzLabel]="section.floor_name">
                </nz-option>
              </nz-select>
              <div class="table-row">
                <button
                  class="table-card"
                  *ngFor="let item of selectedFloorTables"
                  (click)="tableClicked(item.table_no, item.table_id)"
                >
                  {{ item.table_no }}
                </button>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="isPlatformMenuSync && showAutoSync">
            <!-- static Design for Foodpanda -->
            <ng-container *ngIf="!autoSync">
              <div class="p-t-20 p-b-20 ta_center">
                <img
                  class="order-type-img ta_center"
                  style="width: 70px"
                  src="{{ selectedOrder.img }}"
                  [alt]="selectedOrder.name"
                />
              </div>
              <div class="p-l-30 p-r-30">
                <label>
                  {{ 'POS.ENTER_ORDER_ID_LAST_3_4_CHAR' | fallbackTranslate }}
                </label>
                <form nz-form>
                  <nz-form-item>
                    <nz-form-control
                      [nzSpan]="12"
                      [nzValidateStatus]="validityStatus"
                      nzHasFeedback
                    >
                      <nz-input-group
                        [nzAddOnBefore]="restid_code.concat(' -')"
                      >
                        <input
                          type="text"
                          nz-input
                          nzSize="large"
                          placeholder="xxxx-xxxx"
                          class="input-number-class vw-25"
                          autocomplete="off"
                          [(ngModel)]="fp_orderid"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="onOrderIdChanges($event)"
                        />
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                </form>
                <div class="error-field">
                  <p
                    class="ta_center"
                    style="color: #3391fe"
                    *ngIf="validityStatus === 'validating'"
                  >
                    {{ message.validityString }}
                  </p>
                  <p
                    class="ta_center"
                    style="color: #e3502d"
                    *ngIf="validityStatus === 'error'"
                  >
                    {{ message.errorString }}
                  </p>
                  <p
                    class="ta_center"
                    style="color: #f0ab13"
                    *ngIf="validityStatus === 'warning'"
                  >
                    {{ message.warningString }}
                  </p>
                  <p
                    class="ta_center"
                    style="color: #73c61b"
                    *ngIf="validityStatus === 'success'"
                  >
                    {{ message.successString }}
                  </p>
                </div>
              </div>

              <p class="ta_center">OR</p>
              <div
                class="flex_sb"
                [ngStyle]="
                  !(validityStatus == '' || updatePassCodeNeeded)
                    ? { opacity: '0.6' }
                    : { opacity: '1' }
                "
              >
                <button
                  class="create-manually wd-50 m-r-20"
                  (click)="createManually()"
                >
                  {{ 'POS.CREATE_MANUALLY' | fallbackTranslate }}
                </button>
                <button
                  class="save wd-50"
                  (click)="createFPOrders()"
                  *ngIf="!updatePassCodeNeeded"
                >
                  {{ 'POS.AUTO_SYNC' | fallbackTranslate }}
                </button>
                <button
                  class="save wd-50"
                  style="background-color: #3366fb"
                  (click)="updatePassword('update_pass')"
                  *ngIf="updatePassCodeNeeded"
                >
                  {{ 'POS.UPDATE_PASSWORD' | fallbackTranslate }}
                </button>
              </div>
            </ng-container>
            <!-- end static Design for Foodpanda -->
            <ng-container *ngIf="autoSync">
              <div class="platform-loading-container">
                <ng-lottie
                  height="180px"
                  [options]="options"
                  (animationCreated)="animationCreated($event)"
                ></ng-lottie>

                <p class="ta_center m-t-20">
                  {{ 'POS.FETCHING_NEW_ORDERS_FROM' | fallbackTranslate }}
                  {{ selectedOrder.name }}.
                  {{ 'POS.IF_FOUND_NEW_ORDERS_WILL_BE_CREATED' | fallbackTranslate }}
                </p>
                <p class="ta_center">
                  {{ 'POS.THIS_WINDOW_WILL' | fallbackTranslate }}
                </p>

                <div class="ellipsis-loading m-t-10 m-b-30 ta_center">
                  {{ 'POS.PLEASE_WAIT' | fallbackTranslate }}
                </div>
                <div
                  class="ta_center fs-14 m-b-10"
                  style="color: rgb(163, 162, 162)"
                >
                  {{ 'POS.TAKING_TOO_MUCH_TIME' | fallbackTranslate }}
                </div>
                <div class="flex-center">
                  <button class="create-manually" (click)="createManually()">
                    {{ 'POS.CREATE_MANUALLY' | fallbackTranslate }}
                  </button>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <div class="mb-35"></div>
      </div>
    </div>
  </div>
</div>
